/* eslint-disable max-classes-per-file */

import { CONCEPTS } from '@rover/rsdk/src/concepts';
import type { ConsentPurpose } from '@rover/rsdk/src/modules/Analytics';
import { AnalyticsEvent } from '@rover/types/src/Analytics';

/**
 * &nbsp;
 *
 * # Description
 *
 * Fires when a person taps final cta on Desktop or Mobile search modal
 *
 * &nbsp;
 */
export class SearchInterstitialSearchCta extends AnalyticsEvent {
  eventName = 'search-interstitial-search-cta';

  consentPurpose: ConsentPurpose = 'performance';

  concept = CONCEPTS.recommendations.browse_search;
}

/**
 * &nbsp;
 *
 * # Description
 *
 * Fires when a person clicks the "booking fee" link on search header on web/mweb
 *
 * &nbsp;
 */
export class BookingFeeLinkClickSearchEvent extends AnalyticsEvent {
  eventName = 'booking-fee-link-click-search';

  consentPurpose: ConsentPurpose = 'functional';

  concept = CONCEPTS.recommendations.browse_search;
}

/**
 * &nbsp;
 *
 * # Description
 *
 * Fires when a person clicks the "booking fee" link on search header on an SEO page
 *
 * &nbsp;
 */
export class BookingFeeLinkClickSeoEvent extends AnalyticsEvent {
  eventName = 'booking-fee-link-click-seo';

  consentPurpose: ConsentPurpose = 'functional';

  concept = CONCEPTS.recommendations.browse_search;
}
